import { render, staticRenderFns } from "./AccessRow.vue?vue&type=template&id=583363a0&scoped=true"
import script from "./AccessRow.vue?vue&type=script&lang=js"
export * from "./AccessRow.vue?vue&type=script&lang=js"
import style0 from "./AccessRow.vue?vue&type=style&index=0&id=583363a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583363a0",
  null
  
)

export default component.exports